export class Tabs {
    constructor(container = document) {
        this.container = container
        this.blocks = Array.from(this.container.querySelectorAll('.s-tabs'))
        this.init()
    }

    init() {
        this.blocks.forEach((block) => this.setupBlock(block))
    }

    setupBlock(block) {
        const triggers = Array.from(block.querySelectorAll('.s-tabs-trigger'))
        const panels = Array.from(block.querySelectorAll('.s-tabs-panel'))

        block._tabsTriggers = triggers
        block._tabsPanels = panels

        triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => {
                this.activateTab(triggers, panels, trigger)
            })
        })
    }

    activateTab(triggers, panels, activeTrigger) {
        const activeIndex = activeTrigger.getAttribute('data-tab')

        triggers.forEach((trigger) => {
            const isActive = trigger === activeTrigger
            trigger.classList.toggle('is-active', isActive)
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
        })

        panels.forEach((panel) => {
            const panelIndex = panel.getAttribute('data-panel')
            const isActive = panelIndex === activeIndex
            panel.classList.toggle('is-active', isActive)
            panel.hidden = !isActive
        })
    }
}
